export default __webpack_public_path__ + "static/media/h4.edbb6196.jpg";